<div mat-dialog-content>
    <p *ngIf="data.message" class="bold">{{ data.message }}</p>

    <div *ngIf="data.cfms_sites?.length > 0">
        <p>Δεν βρέθηκε φυσική απογραφή για τις ακόλουθες εγκαταστάσεις:</p>
        <ul>
            <li *ngFor="let site of data.cfms_sites" class="bold">{{ site }}</li>
        </ul>
    </div>

    <div *ngIf="data.vrs_stations?.length > 0">
        <p>Δεν βρέθηκε απογραφή VRS για τους ακόλουθους σταθμούς:</p>
        <ul>
            <li *ngFor="let station of data.vrs_stations" class="bold">{{ station }}</li>
        </ul>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button class="cancel-button" (click)="onCancel()">Κλείσιμο</button>
</div>